import {btn, Component, Notifier, router, tbar} from "@intermesh/goui";
import {registrationForm} from "./components/RegistrationForm.js";
import {t} from "./util/Translate.js";
import {PasswordUpdateDialog} from "./PasswordUpdateDialog.js";
import {CurrentParticipant} from "./services/CurrentParticipant.js";
import {ServerApi} from "./util/ServerApi.js";
import {IfwInvalidator} from "./util/IfwInvalidator.js";

export class ParticipantEdit extends Component {
	constructor() {
		super("section");
		this.itemId = "confirm-registration";
		this.id = "confirm-registration";
		this.cls = "card";

		const p = registrationForm({});

		p.form.on("submit", async () => {
			const v = p.form.value;
			let cp = CurrentParticipant.get(),
				body = {
					id: cp.id,
					firstName: v.firstName,
					middleName: v.middleName,
					lastName: v.lastName,
					dateOfBirth: v.dateOfBirth,
					email: v.email,
					company: v.company,
					remindMe: v.remindMe,
					customFields: []
				};
			if (Object.keys(v.customFields).length > 0) {
				body.customFields = v.customFields;
			}

			sessionStorage.setItem(CurrentParticipant.storageItem, JSON.stringify(cp));

			// We only need to validate the fields in the body.
			const url = ServerApi.url("elearning/frontend/participants/validate", {});
			ServerApi.call(url, body, "POST").then((result) => {
				if (!result.success && result.data && result.data.user) {
					const userData = result.data.user;
					// TODO?: Should this not be merged with the catch() below?
					for (const fld in userData.validationErrors) {
						const err = userData.validationErrors[fld];
						if (fld === "password") {
							IfwInvalidator.setInvalidPasswordMessage(p.passwordFld, err);
						} else if (fld === "username") {
							p.usernameFld.setInvalid(t("Sorry, this username is already taken"));
						}
					}
					return;
				} else if (result.errors && result.errors.length > 0) {
					throw result.errors[0];
				}
				void router.goto("confirm-participant-edit");
			}).catch((reason) => {
				if (reason.validationErrors) {
					Object.entries(reason.validationErrors).forEach(([key, value]: [string, any]) => {
						if (key === "email") {
							p.emailFld.setInvalid(t(value.description));
						}
					});
				}
				Notifier.error(reason);
			})

		});

		p.load().then(() => {
			// Y THO?
			p.form.findChild("username")!.hide();
			p.form.findChild("username")!.disabled = true;
			p.form.findChild("password")!.hide();
			p.form.findChild("password")!.disabled = true;
			p.form.findChild("passwordRepeat")!.hide();
			p.form.findChild("passwordRepeat")!.disabled = true;

			p.form.items.first()!.items.add(
				btn({
					width: 300,
					cls: "outlined",
					text: t("Change Password"),
					handler: () => {
						const d = new PasswordUpdateDialog();
						d.show();
					}
				})
			);

			this.items.add(p);

			this.items.add(tbar({},
				btn({text: t("Back"), route: "profile"}),
				"->",
				btn({
					type: "submit", text: t("Continue"), handler: () => {
						p.form.submit();
					}
				})
			));
		});
	}

}
